<template>
    <jet-dialog-modal 
        :show="isOpen" 
        ref="modal"
        @close="closeModal"
        max-width="2xl"
    >
        <template #title>
            <div class="flex justify-between items-center">
                <h2 class="text-2xl font-bold">Get Started with TextSpot</h2>
                <button @click="closeModal" class="text-gray-400 hover:text-gray-600">
                    <font-awesome-icon :icon="['fas', 'times']" class="h-5 w-5" />
                </button>
            </div>
        </template>

        <template #content>
            <div class="space-y-6 py-4">
                <!-- Step 1 -->
                <div class="flex gap-4">
                    <div class="bg-gray-100 rounded-full h-8 w-8 flex items-center justify-center text-gray-700 font-bold flex-shrink-0 mt-1">
                        1
                    </div>
                    <div>
                        <h3 class="text-lg font-semibold mb-1 text-gray-800">Pick Your Plan</h3>
                        <p class="text-gray-700">Upgrade or downgrade at any time.</p>
                    </div>
                </div>
                
                <!-- Step 2 -->
                <div class="flex gap-4">
                    <div class="bg-gray-100 rounded-full h-8 w-8 flex items-center justify-center text-gray-700 font-bold flex-shrink-0 mt-1">
                        2
                    </div>
                    <div>
                        <h3 class="text-lg text-gray-800 font-semibold mb-1">Pick Your Phone Number</h3>
                        <p class="text-gray-700">Search for a local number in an area code of your choice.</p>
                    </div>
                </div>
                
                <!-- Step 3 -->
                <div class="flex gap-4">
                    <div class="bg-gray-100 rounded-full h-8 w-8 flex items-center justify-center text-gray-700 font-bold flex-shrink-0 mt-1">
                        3
                    </div>
                    <div>
                        <h3 class="text-lg text-gray-800 font-semibold mb-1">Register with Carriers (one-time $19 fee)</h3>
                        <p class="text-gray-700">
                            Complete your application in TextSpot and get verified within 1-3 business days.
                        </p>
                    </div>
                </div>
                
                <!-- Step 4 -->
                <div class="flex gap-4">
                    <div class="bg-gray-100 rounded-full h-8 w-8 flex items-center justify-center text-gray-700 font-bold flex-shrink-0 mt-1">
                        4
                    </div>
                    <div>
                        <h3 class="text-lg text-gray-800 font-semibold mb-1">Send Messages</h3>
                        <p class="text-gray-700">
                            Start sending messages to your contacts from TextSpot right away.
                        </p>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="w-full">
                <jet-button 
                    class="w-full justify-center mb-4" 
                    size="lg"
                    @click="continueWithPlan"
                >
                    Continue with {{ selectedPlan.limit?.toLocaleString() || '' }} {{ planType }} plan{{ billingType }}
                </jet-button>
                <p class="text-center text-sm text-gray-500">
                    By continuing, you agree to TextSpot's <a href="https://textspot.io/terms/" target="_blank" class="underline">Terms of Service and Use</a> and <a href="https://textspot.io/anti-spam-policy/" target="_blank" class="underline">Anti-Spam Policy</a>
                </p>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

export default {
    name: 'GetStartedModal',
    components: {
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        selectedPlan: {
            type: Object,
            default: () => ({})
        },
        showAnnualPrices: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close', 'continue'],
    computed: {
        planType() {
            return this.showAnnualPrices ? 'credits' : 'credits';
        },
        billingType() {
            return this.showAnnualPrices ? ' (annual)' : '';
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        continueWithPlan() {
            this.$emit('continue', this.selectedPlan);
            this.closeModal();
        }
    }
};
</script>